<template>
    <div class="offcanvas mobile-filter is-left">
        <button class="btn btn-block offcanvas-close" @click="closeFilter()">
            {{ $translate("Ceres::Template.itemFilter") }}
            <svg class="icon icon-x" width="32" height="32" fill="currentColor">
                <use xlink:href="#x" />
            </svg>
        </button>
        <portal-target class="offcanvas-content-container" name="mobile-filter"></portal-target>
    </div>
</template>
<script>
export default {
    name: 'mobile-filter',
    methods:{
        closeFilter()
        {
            document.querySelector(".mobile-filter").classList.remove("open");
            document.querySelector("body").classList.remove("menu-is-visible");
        },
    }
};
</script>
